module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: ['container', {
      'containerGreen': _vm.orderType == 3
    }]
  }, [_c('div', {
    staticClass: "x-qrcode"
  }, [_c('div', {
    staticClass: "tit"
  }, [_vm._v(_vm._s(_vm.orderType == 1 ? '自提' : '堂食'))]), _vm._v(" "), _c('div', {
    staticClass: "code"
  }, [_vm._v(_vm._s(JSON.parse(_vm.code).orderShortNum))]), _vm._v(" "), _c('div', {
    staticClass: "tit"
  }, [_vm._v("商家名称")]), _vm._v(" "), _c('div', {
    staticClass: "code"
  }, [_vm._v(_vm._s(_vm.supplier_name))]), _vm._v(" "), _c('div', {
    staticClass: "tit"
  }, [_vm._v(_vm._s(_vm.orderType == 1 ? '自提时间：' : '就餐时间：'))]), _vm._v(" "), _c('div', {
    staticClass: "code"
  }, [_vm._v(_vm._s(_vm.deliveryTime))]), _vm._v(" "), (_vm.isInvalid != 2) ? _c('div', {
    attrs: {
      "id": "qrcode"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.isInvalid == 2 && _vm.orderType == 3) ? _c('div', {
    staticStyle: {
      "background": "rgba(255,255,255,0.50)",
      "text-align": "center"
    }
  }, [_c('img', {
    staticClass: "qr-mask",
    attrs: {
      "src": require("../assets/images/qr-mask.png"),
      "alt": ""
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "time-out"
  }, [_vm._v("已过用餐时间，二维码失效")])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticStyle: {
      "text-align": "center",
      "width": "100%"
    }
  }, [_c('div', {
    staticClass: "red ac",
    staticStyle: {
      "margin-top": ".08rem",
      "font-size": ".24rem"
    }
  }, [_vm._v(_vm._s(_vm.qrCodeIndate))]), _vm._v(" "), _c('div', {
    staticClass: "tip"
  }, [_vm._v("取餐时出示给商家/同学，完成堂食或自提订单验证")])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/_vue-loader@12.2.2@vue-loader/lib/template-compiler?{"id":"data-v-6daf84e8","hasScoped":true}!./~/_vue-loader@12.2.2@vue-loader/lib/selector.js?type=template&index=0!./src/pages/QrCode.vue
// module id = 450
// module chunks = 7